module.exports = __webpack_public_path__ + "img/7.4b4e8b95.png";